/* ============================================================================
   LP SEO — Add-to-Cart form handler

   Intercepts submit events on `<form data-lp-atc>` inside any LP SEO section
   and POSTs to /cart/add.js. The theme's UpCart app (see assets/main.js)
   listens for /cart/add.js requests and opens its drawer automatically, so
   this handler only needs to fire the AJAX and surface the theme's native
   .mini-cart drawer as a fallback if UpCart isn't available.

   Design goals:
     - Progressive enhancement. If this JS fails or is blocked, the form
       submits natively and Shopify redirects to /cart.
     - No jQuery dependency. The theme ships jQuery but this asset stays
       self-contained so it works even if jQuery hasn't loaded yet.
     - Single delegated listener. Zero per-form wiring.
   ============================================================================ */
(function () {
  'use strict';

  if (typeof document === 'undefined') return;

  function openThemeFallbackDrawer() {
    var miniCart = document.querySelector('.mini-cart');
    if (!miniCart) return false;
    miniCart.classList.add('show');
    var bg = document.querySelector('.mm-fullscreen-bg');
    if (bg) bg.classList.add('active');
    document.body.classList.add('hidden');
    return true;
  }

  function updateHeaderCartCount(itemCount) {
    // Theme headers render the cart count in elements with class .bigcounter
    // or .cart-count-item. Update all of them so whichever header is active
    // stays in sync.
    var selectors = ['.bigcounter', '.cart-count-item', '.cart-count'];
    selectors.forEach(function (sel) {
      document.querySelectorAll(sel).forEach(function (el) {
        el.textContent = itemCount;
      });
    });
  }

  document.addEventListener('submit', function (evt) {
    var form = evt.target;
    if (!form || typeof form.matches !== 'function') return;
    if (!form.matches('form.lp-seo-atc-form[data-lp-atc]')) return;

    evt.preventDefault();

    var btn = form.querySelector('button[type="submit"], [type="submit"]');
    if (btn) {
      btn.disabled = true;
      btn.classList.add('is-adding');
    }

    var fd = new FormData(form);

    fetch('/cart/add.js', {
      method: 'POST',
      body: fd,
      headers: {
        'X-Requested-With': 'XMLHttpRequest',
        'Accept': 'application/json'
      },
      credentials: 'same-origin'
    })
      .then(function (res) {
        if (!res.ok) {
          // Shopify returns JSON errors (e.g. sold out). Propagate to catch.
          return res.json().then(function (body) {
            var err = new Error(body && body.description ? body.description : 'add failed');
            err.status = res.status;
            err.body = body;
            throw err;
          });
        }
        return res.json();
      })
      .then(function () {
        if (btn) {
          btn.classList.remove('is-adding');
          btn.classList.add('is-added');
        }
        // Fetch fresh cart count so the header updates even if UpCart's own
        // listeners don't.
        return fetch('/cart.js', {
          headers: { 'Accept': 'application/json' },
          credentials: 'same-origin'
        });
      })
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        updateHeaderCartCount(cart.item_count);
        // UpCart's injected script patches fetch/XHR and opens its drawer
        // automatically when /cart/add.js fires. If UpCart isn't present,
        // fall back to the theme's built-in .mini-cart side drawer.
        var upcartActive = typeof window.upcartRegisterAddToCart === 'function';
        if (!upcartActive) {
          openThemeFallbackDrawer();
        }
      })
      .catch(function (err) {
        // If the AJAX path failed, let the form submit natively so the user
        // still lands on /cart with the item added (or sees Shopify's error).
        if (window && window.console && console.warn) {
          console.warn('LP ATC fallback', err);
        }
        form.removeAttribute('data-lp-atc');
        try {
          form.submit();
        } catch (_) {
          window.location.href = '/cart';
        }
      })
      .then(function () {
        // finally-style cleanup regardless of path
        if (btn) {
          btn.disabled = false;
          // Leave is-added on the element briefly so CSS can flash a
          // confirmation state; clear it after 2s.
          setTimeout(function () {
            if (btn.classList) btn.classList.remove('is-added');
          }, 2000);
        }
      });
  }, false);
})();
